const rareEarthsData = {
  hero: 'https://res.cloudinary.com/benchmarkminerals/image/upload/v1732133790/assets/data-reports/price-assessments/benchmarkminerals_Graphs_and_charts_photorealistic_realistic_sh_5ec62e31-e9e0-449b-aee6-4884a93d0b9f_lrcl0h.png',
  priceAssessmentsBrochureFile: {
    file_name: 'Benchmark-Rare-Earths-Price-Assessment-Methodology.pdf',
    category: 'methodology-price-assessments',
    EnvKey: 'rareEarthsPriceAssessmentsMethodologyId',
  },
  forecastBrochureFile: {
    EnvKey: 'forecastBrochureRareEarthsFilePdfID',
    file_name: 'Rare Earths Forecast Brochure.pdf',
    category: 'public-documents',
  },
  esgBrochureFile: {
    file_name: 'Rare Earths Sustainability Brochure.pdf',
    category: 'rare-earths-esg-brochure',
    EnvKey: 'ESGBrochureRareEarthsFilePdfId',
  },
  banner: {
    title:
      'Benchmark’s Rare Earths Forecast service provides a detailed assessment of supply, demand and prices and is updated on a quarterly basis:',
    descriptions: [
      {
        items: [
          '<strong>Mine by Mine:</strong> Supply analysis by element, broken down by asset outside of China, and a legal entity basis within China.',
          '<strong>Plant by Plant:</strong> Granular review of processed materials by operation outside of China, including material flows to processing facilities within China.',
          '<strong>Demand Analysis:</strong> Rare earth oxide and magnet demand by category and regional end-use sector, including assessment of short-term market movements, shown on a monthly frequency.',
          '<strong>Battery Demand:</strong> Scenarios of EV, Stationary and Portable Tech',
          '<strong>Price Forecasts:</strong> PrNd Oxide, PrNd Mischmetal, Nd Oxide, Pr Oxide, Dy Oxide and Tb Oxide.',
        ],
      },
    ],
    images: {
      one: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719605738/assets/data-reports/rare-earths/1_qymrhv.png',
        alt: 'Rare Earths Forecasts',
      },
      two: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719605736/assets/data-reports/rare-earths/2_vogyfw.png',
        alt: 'Rare Earths Forecasts',
      },
      three: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719605737/assets/data-reports/rare-earths/3_csiewy.png',
        alt: 'Rare Earths Forecasts',
      },
    },
  },
  sections: {
    one: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,h_700,f_auto/v1719605737/assets/data-reports/rare-earths/3_csiewy.png',
      title:
        'Our Rare Earths Forecast service features detailed data and analysis out to 2040:',
      descriptions: [
        {
          subtitle: '',
          items: [
            '<strong>Market balances:</strong> Compare rare earths market balances by raw material and processed product for a thorough view of the market, including a high frequency short-term view.',
            '<strong>Demand drivers:</strong> Material-specific demand breakdowns out to 2040.',
            '<strong>Regional perspectives:</strong> Examine rare earths mined and processed supply dynamics on a regional and asset basis.',
            '<strong>Developments:</strong> Track key investments, partnerships and announcements over each quarter.',
          ],
        },
      ],
    },
    two: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,h_500,f_auto/v1719605737/assets/data-reports/rare-earths/5_wjpddj.png',
      title:
        'You will receive full, unrestricted access to the data behind Benchmark’s Rare Earths Forecasts:',
      descriptions: [
        {
          items: [
            '<strong>Online accessible</strong> downloads each quarter',
            '<strong>Clear & Concise:</strong> Your data is presented in excel and pdf format',
          ],
        },
      ],
    },
  },
  indexTab: true,
}
export default rareEarthsData
